// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"85b3e7db","420":"8df9e833","473":"b1265180","770":"42ff625a","791":"f4976b94"}[chunkId] + ".css";
};